import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Pre-baked shapes; `box` is the default rectangular placeholder. */
  shape?: 'box' | 'pill' | 'circle' | 'text';
}

const shapeClasses: Record<NonNullable<SkeletonProps['shape']>, string> = {
  box: 'rounded-lg',
  pill: 'rounded-full',
  circle: 'rounded-full aspect-square',
  text: 'rounded h-3',
};

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
  { shape = 'box', className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      role="status"
      aria-label="Loading"
      aria-busy="true"
      className={cn(
        'animate-pulse bg-rail motion-reduce:animate-none',
        shapeClasses[shape],
        className,
      )}
      {...rest}
    />
  );
});
